var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-content"},[_c('div',{staticClass:"header-left"},[_c('h4',[_vm._v(_vm._s(_vm.$t("ranking-history"))+" - "+_vm._s(_vm._f("PopupDateFilter")(_vm.updateDate)))])])])}
var staticRenderFns = []

export { render, staticRenderFns }